

export const _en = {
    title: {
        prod: { label: "Neoplan" },
        test: { label: "Neoplan-test" },
        formation: { label: "Neoplan-training" }
    },

    planningItem: { label: "Timeline" },
    macroPlanningItem: {
        label: "Macro view"
    },
    alertDashboard: {
        label: "Alerts"
    },
    namedResourceItem: {
        label: "Named resources"
    },
    AvailabilitiesItem: {
        label: "Availabilities"
    },
    productModelItem: {
        label: "Product model"
    },
    timetableItem: {
        label: "Timetable"
    },
    trainingCourseItem: {
        label: "Training courses"
    },
    dailyView: {
        label: "Daily view"
    },
    adminMenu: {
        label: "Management",
        resourceItem: {
            label: "Resources type referential"
        },
        divisionItem: {
            label: "Divisions referential"
        },
        taskItem: {
            label: "Tasks referential"
        },
        skillItem: {
            label: "Skills referential"
        },
        planeItem: {
            label: "Planes types referential"
        },
        changelogItem: {
            label: "Changelog"
        },
        exportItem: {
            label: "Exports"
        },
        productStatesItem: {
            label: "Training product states referential"
        },
        prefixItem: {
            label: "Training product prefixes referential"
        },
        locationItem: {
            label: "Locations referential"
        },
        skillLevelItem: {
            label: "Skill levels referential"
        },
        refTimeVacations: {
            label: "Vacations referential"
        },
        resourceSkillItem: {
            label: "Combining skills"
        },
        refServiceProvider: {
            label: "Service provider referential"
        },
        refRule: {
            label: "Rules referential"
        },
        refEngineRule: {
            label: "Engine rules referential"
        },
        refOrganizationsItem: {
            label: "Organizations referential"
        },
        refCodeEventsItem: {
            label: "Code events referential"
        },
        refTrainingProductStatesItem: {
            label: "Training product states referential"
        },
        fluxItem: {
            label: "Flux"
        },
        usersProfilesAdministrationPagesAccess: {
            label: "Profiles"
        },
        refInstructorRoles: {
            label: "Instructor Role referential"
        }
        ,
        refSeasons: {
            label: "Seasons referential"
        }
        ,
        refGroups: {
            label: "Groups referential"
        }
        ,
        refTimeCodes: {
            label: "Time codes"
        }
        ,
        namedResourcesItem: {
            label: "Named resources"
        }
        ,
        refPlanningTemplate: {
            label: "Planning Template"
        },
        globalMessages: {
            label: "Global messages"
        }
    },
    resourceDropDownMenu: {
        label: "Resources"
    },
    schedulingDropDownMenu: {
        label: "Scheduling"
    },
    referentialDropDownMenu: {
        label: "Referential"
    },
    administrationDropDownMenu: {
        label: "Administration"
    },
    profile: {
        title: "Profile",
        id: {
            label: "UID: "
        },
        surname: {
            label: "Surname: "
        },
        givenName: {
            label: "Given name: "
        },
        profiles: {
            label: "Profile: "
        }
    },
    version: {
        number: {
            label: "v. "
        },
        date: {
            label: "Deployment: "
        }
    }
};

export const _fr = {
    title: {
        prod: { label: "NEOPLAN" },
        test: { label: "NEOPLAN-test" },
        formation: { label: "NEOPLAN-formation" }
    },

    planningItem: { label: "Timeline" },
    macroPlanningItem: {
        label: "Vue macro"
    },
    namedResourceItem: {
        label: "Ressources"
    },
    AvailabilitiesItem: {
        label: "Horaires de planification"
    },
    timetableItem: {
        label: "Grilles horaires"
    },
    trainingCourseItem: {
        label: "Stages"
    },
    productModelItem: {
        label: "Modèles de stage"
    },
    alertDashboard: {
        label: "Alertes"
    },
    dailyView: {
        label: "Vue journalière"
    },
    adminMenu: {
        label: "Administration",
        resourceItem: {
            label: "Types de ressources"
        },
        divisionItem: {
            label: "Services"
        },
        taskItem: {
            label: "Catégories et types de séances"
        },
        skillItem: {
            label: "Compétences / Caractéristiques"
        },
        planeItem: {
            label: "Types avions"
        },
        changelogItem: {
            label: "Suivi des versions"
        },
        exportItem: {
            label: "Exports"
        },
        productStatesItem: {
            label: "États des modèles de stage"
        },
        prefixItem: {
            label: "Préfixes/Codes de stage"
        },
        locationItem: {
            label: "Sites"
        },
        skillLevelItem: {
            label: "Niveaux de compétences"
        },
        refTimeVacations: {
            label: "Vacations"
        },
        resourceSkillItem: {
            label: "Association des compétences"
        },
        fluxItem: {
            label: "Flux"
        },
        refServiceProvider: {
            label: "Sociétés"
        },
        refRule: {
            label: "Règles"
        },
        refEngineRule: {
            label: "Contraintes de planification"
        },
        refOrganizationsItem: {
            label: "Compagnies"
        },
        refCodeEventsItem: {
            label: "Codes évènements"
        },
        refTrainingProductStatesItem: {
            label: "Statuts de stage"
        },
        usersProfilesAdministrationPagesAccess: {
            label: "Gestion des profils"
        },
        refInstructorRoles: {
            label: "Rôles instructeurs"
        },
        refSeasons: {
            label: "Saisons"
        },
        refGroups: {
            label: "Groupes"
        }
        ,
        refTimeCodes: {
            label: "Codes horaires"
        }
        ,
        namedResourcesItem: {
            label: "Resources nommées"
        },
        refPlanningTemplate: {
            label: "Modèles de vue planning"
        },
        globalMessages: {
            label: "Messages globaux"
        }
    },
    resourceDropDownMenu: {
        label: "Ressources"
    },
    schedulingDropDownMenu: {
        label: "Planification"
    },
    referentialDropDownMenu: {
        label: "Référentiels"
    },
    administrationDropDownMenu: {
        label: "Administration"
    },
    profile: {
        title: "Profil",
        id: {
            label: "Matricule : "
        },
        surname: {
            label: "Nom de famille : "
        },
        givenName: {
            label: "Prénom : "
        },
        profiles: {
            label: "Profil : "
        }
    },
    version: {
        number: {
            label: "v. "
        },
        date: {
            label: "Déploiement: "
        }
    }
};